import { IPlayerProps, Player } from "@lottiefiles/react-lottie-player";
import { classNames } from "primereact/utils";
import { useMemo } from "react";
import { IconColorPalette, getJsonWithNewColors } from "./helper";
import * as IconData from "./iconJson";

export type IconType = (typeof IconData)[keyof typeof IconData];

//
// if you need some more icons, find them at:
// https://dev.azure.com/betterspace/better.core/_git/better.ui.icons
//

export interface IconProps extends Omit<IPlayerProps, "src"> {
    type: string | null;
    color?: IconColorPalette;
    style?: Object;
    height?: string | number | null | undefined;
    width?: string | number | null | undefined;
    id?: string;
    speed?: number;
    innerClassName?: string;
    hover?: boolean;
    onClick?: VoidFunction;
}

export const IconNames = Object.keys(IconData);

export const Icon = (props: IconProps) => {
    const {
        style = {},
        type,
        color = null,
        width,
        height,
        className,
        innerClassName,
        id,
        speed = 1,
        hover = true,
        onClick,
        ...rest
    } = props;

    const srcResult = useMemo(() => {
        // @ts-ignore
        const srcJson = IconData[type];
        return getJsonWithNewColors(srcJson, color);
    }, [type, color]);

    const sizes = {
        width: width || "100%",
        height: height || "100%",
    };

    return (
        <div
            className={classNames("icon-container", className, {
                "cursor-pointer": !!onClick,
            })}
            id={id}
            onClick={onClick}
        >
            <Player
                className={innerClassName}
                autoplay={false}
                controls={false}
                hover={hover}
                speed={speed}
                style={{ ...sizes, ...style }}
                {...rest}
                src={srcResult}
            ></Player>
        </div>
    );
};
